import React from "react";
import './Products.css'
import paintIcon from '../../assets/paintIcon.webp'
import plasticIcon from '../../assets/plasticIcon.webp'
import textileIcon from '../../assets/textileIcon.webp'
import chemicalIcon from '../../assets/chemicalIcon.webp'
import foodIcon from '../../assets/foodIcon.webp'
import soapIcon from '../../assets/soapIcon.webp'
import Gettouch from "../../components/getTouch/Gettouch";
import { Link } from "react-router-dom";

const Products = () => {
    return (
        <div className="Products-Main-Container">
                 <div className='About-We-Offer-Main-Container'>
                <h1>What We Offer</h1>
                <div className='About-We-Offer-Row-Align-Container'>
                    <div className='About-We-Offer-Products-Types-Card'>
                        <h2>SALTS</h2>
                        <p>Our premium quality salts are perfect for culinary, industrial, and agricultural needs. We offer a variety of salts, each with specific applications and benefits.</p>
                        <Link to="/salts" className='About-We-Offer-More-Btn'>Know More</Link>
                    </div>
                    <div className='About-We-Offer-Products-Types-Card'>
                        <h2>MINERALS</h2>
                        <p>We provide high-quality minerals for various industries, offering essential nutrients and compounds that support manufacturing and health sectors.</p>
                        <Link to="/minerals" className='About-We-Offer-More-Btn'>Know More</Link>
                    </div>
                    <div className='About-We-Offer-Products-Types-Card'>
                        <h2>CHEMICALS</h2>
                        <p>Our chemicals are carefully sourced and processed for a wide range of industrial applications, ensuring efficiency, safety, and reliability in all uses.</p>
                        <Link to="/checmicals" className='About-We-Offer-More-Btn'>Know More</Link>
                    </div>
                </div>
            </div>

            <div className="Home-Industry-Serve-Main-Container">
                <h1>INDUSTRIES WE SERVE</h1>
                <div className="Home-Industry-Serve-Grid-Container">
                <Link to="/industriesWeServe#textile" className="Home-Industry-Card-Container">
                            <img src={textileIcon} alt="textileIcon" className="Home-Industry-Section-Img" />
                            <h3>Textile Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#food" className="Home-Industry-Card-Container">
                            <img src={foodIcon} alt="foodIcon" className="Home-Industry-Section-Img" />
                            <h3>Food Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#paint" className="Home-Industry-Card-Container">
                            <img src={paintIcon} alt="paintIcon" className="Home-Industry-Section-Img" />
                            <h3>Paint Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#plastic" className="Home-Industry-Card-Container">
                            <img src={plasticIcon} alt="plasticIcon" className="Home-Industry-Section-Img" />
                            <h3>Plastic Industries</h3>
                        </Link>

                        <Link to="/industriesWeServe#chemical" className="Home-Industry-Card-Container">
                            <img src={chemicalIcon} alt="chemicalIcon" className="Home-Industry-Section-Img" />
                            <h3>Chemical Industries</h3>
                        </Link>
                        <Link to="/industriesWeServe#soap" className="Home-Industry-Card-Container">
                            <img src={soapIcon} alt="soapIcon" className="Home-Industry-Section-Img" />
                            <h3>Soap Industries</h3>
                        </Link>
                </div>
            </div>

           
            <Gettouch />
        </div>
    )
}
export default Products;